import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { PagingAndOrderingModel } from '@common/models/common/PagingAndOrdering.model';

export class ContainerFromBulPCSListFilter extends PagingAndOrderingModel {
    line: string;
    booking: string;
    billsOfLading: string;
    fullOrEmpty: string;
    serviceRequestId: number;
    agentId: number;
    releaseOrderId: number;
    releaseOrderNumber: string;
    vesselVisitId: number;
    containers: string;
    inboundVessels: boolean;

    constructor(pageFilter?: PagingAndOrderingModel, data = null) {
        super();

        if (data) {
            Object.assign(this, data);
        }
    }

    createFormGroup() {
        const form = new UntypedFormGroup({
            line: new UntypedFormControl({ value: null, disabled: false }),
            booking: new UntypedFormControl({ value: null, disabled: false }),
            billsOfLading: new UntypedFormControl({ value: null, disabled: false }),
            fullOrEmpty: new UntypedFormControl({ value: null, disabled: true }),
            releaseOrderNumber: new UntypedFormControl({ value: null, disabled: false }),
            vesselVisitId: new UntypedFormControl({ value: null, disabled: false }),
            containers: new UntypedFormControl({ value: null, disabled: false }),
            loadingVoyageNumber: new UntypedFormControl({ value: null, disabled: false }),
            unloadingVoyageNumber: new UntypedFormControl({ value: null, disabled: false }),
            inboundVessels: new UntypedFormControl({ value: null, disabled: false }),
            status: new UntypedFormControl({ value: null, disabled: false })
        });
        form.patchValue(this);
        return form;
    }
}
